import { useStats } from '../contexts/StatsContext'
import { describeStreak, type StreakTone } from '../utils/streakCopy'

const ICONS: Record<StreakTone, string> = { start: '🔥', ok: '🔥', warning: '⏳', celebrate: '🎉' }

const TONE_CLASSES: Record<StreakTone, string> = {
  start: 'bg-white/5 border-white/10',
  ok: 'bg-orange-500/10 border-orange-500/30',
  warning: 'bg-red-400/10 border-red-400/40',
  celebrate: 'bg-purple-500/15 border-purple-500/50',
}

// The daily streak, read from the server. Shows nothing until there is an
// answer (no flash of a wrong number), and nothing if it can't be reached.
export function StreakCard() {
  const { data } = useStats()
  if (!data) return null

  const message = describeStreak(data.streak)

  return (
    <div
      data-testid="streak-card"
      role="group"
      aria-label={`${message.title}. ${message.detail}${message.freezeNote ? ` ${message.freezeNote}` : ''}`}
      className={`flex w-full items-center gap-3 rounded-2xl border p-4 text-left ${TONE_CLASSES[message.tone]}`}>
      <span aria-hidden="true" className="text-3xl">
        {ICONS[message.tone]}
      </span>
      <div className="flex-1">
        <p data-testid="streak-title" className="font-bold text-white">
          {message.title}
        </p>
        <p data-testid="streak-detail" className="text-sm text-white/75">
          {message.detail}
        </p>
        {message.freezeNote && (
          <p data-testid="streak-freeze" className="mt-1 text-xs text-sky-200/90">
            ❄️ {message.freezeNote}
          </p>
        )}
      </div>
    </div>
  )
}
